import React from 'react';
import { TextInput, SelectInput } from 'react-admin';

import Create from '../common/views/Create';
import SimpleForm from '../common/forms/SimpleForm';
import { industryChoices } from '../common/constants/industryChoices';

const CustomerCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="short_name" />
            <SelectInput source="industry" label="Industry" choices={industryChoices} />
            <TextInput source="description" multiline fullWidth rows="4" />
        </SimpleForm>
    </Create>
);

export default CustomerCreate;
